import { useState, useCallback, useEffect } from 'react';
export function useWakeLock() {
    const [wakeLock, setWakeLock] = useState(null);
    const [isSupported] = useState(() => typeof navigator !== 'undefined' && 'wakeLock' in navigator);
    const requestWakeLock = useCallback(async () => {
        if (!isSupported)
            return;
        try {
            const lock = await navigator.wakeLock.request('screen');
            setWakeLock(lock);
            // Re-acquire if released due to visibility change
            lock.addEventListener('release', () => {
                setWakeLock(null);
            });
        }
        catch (err) {
            console.error('Failed to acquire wake lock:', err);
        }
    }, [isSupported]);
    const releaseWakeLock = useCallback(async () => {
        if (wakeLock) {
            await wakeLock.release();
            setWakeLock(null);
        }
    }, [wakeLock]);
    // Re-acquire on visibility change
    useEffect(() => {
        if (!wakeLock || !isSupported)
            return;
        const handleVisibilityChange = async () => {
            if (document.visibilityState === 'visible' && !wakeLock) {
                await requestWakeLock();
            }
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
    }, [wakeLock, isSupported, requestWakeLock]);
    return {
        isActive: !!wakeLock,
        isSupported,
        requestWakeLock,
        releaseWakeLock,
    };
}
